import * as React from "react";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { observable } from "mobx";
import autobind from "autobind-decorator";
import Grid from "@mui/material/Grid";
import { Button, Snackbar } from "@mui/material";
import { CircularProgress } from "@mui/material";
import { RouterStore } from "mobx-react-router";
import { inject, observer } from "mobx-react";
import AccountService from "../../service/AccountService";
import { StyledAvatar } from "../common/StyledAvatar";

const Paper = styled("div")((props) => ({
  marginTop: props.theme.spacing(8),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));
const Form = styled("form")((props) => ({
  width: "100%", // Fix IE 11 issue.
  marginTop: props.theme.spacing(1),
}));
const SubmitButton = styled(Button)((props) => ({
  margin: props.theme.spacing(3, 0, 2),
  minWidth: "120px",
}));

type AdminLoginProps = {
  routing?: RouterStore;
  account?: AccountService;
};

@inject("routing")
@inject("account")
@observer
export default class AdminLogin extends React.Component<AdminLoginProps> {
  @observable
  private _status = "NORMAL";

  @observable
  private _email = "";

  @observable
  private _password = "";

  @observable
  snackMessage = "";

  @autobind
  handleEmailChange(event) {
    this._email = event.target.value?.trim();
  }

  @autobind
  handlePasswordChange(event) {
    this._password = event.target.value;
  }

  // @autobind
  // handleUserLogin(){
  //     this.props.routing.push("/login")
  // }

  getEmailErrorMessage(): string {
    if (this._status == "INVALID_EMAIL") {
      return "Email is invalid.";
    }

    if (this._status == "NO_SUCH_USER") {
      return "Email is not registered.";
    }
    return null;
  }

  getPasswordErrorMessage(): string {
    if (this._status == "INVALID_PASSWORD") {
      return "Password is invalid.";
    }
    return null;
  }

  @autobind
  async handleSubmit(event) {
    event.preventDefault();
    this._status = "LOADING";
    var { account, routing } = this.props;
    this._status = await account.handleAdminLogin(this._email, this._password);

    if (this._status == "SUCCESS") {
      routing.replace("/admin");
    }
  }

  render() {
    var emailError = this.getEmailErrorMessage();
    var passwordError = this.getPasswordErrorMessage();

    return (
      <Container component="main" maxWidth="xs">
        <Paper>
          <StyledAvatar img={require("../../assets/favicon.ico")} />

          <Typography component="h1" variant="h5">
            Admin Log in
          </Typography>
          <Form noValidate onSubmit={this.handleSubmit}>
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              label="Email Address"
              autoComplete="email"
              autoFocus
              value={this._email}
              onChange={this.handleEmailChange}
              error={emailError != null}
              helperText={emailError}
            />

            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              label="Password"
              type="password"
              autoComplete="current-password"
              value={this._password}
              onChange={this.handlePasswordChange}
              error={passwordError != null}
              helperText={passwordError}
            />

            <Grid container justifyContent="center">
              <SubmitButton
                type="submit"
                variant="contained"
                color="primary"
                disabled={this._status == "LOADING"}
              >
                {this._status == "LOADING" ? (
                  <CircularProgress size={18} />
                ) : (
                  <Typography>Log In</Typography>
                )}
              </SubmitButton>

              <div style={{ width: "12px" }} />
            </Grid>

            {/* <div style={{ height: '18px' }} />
                        
						<Grid container direction="row" justify="center">
							<SubmitButton type="button" variant="contained" color="secondary" onClick={this.handleUserLogin}
								disabled={this._status == "LOADING"}>
								<Typography>USER LOGIN</Typography>
                			</SubmitButton>
						</Grid> */}
          </Form>

          <Snackbar
            open={this.snackMessage ? true : false}
            autoHideDuration={6000}
            onClose={() => (this.snackMessage = null)}
          >
            <div
              style={{
                backgroundColor: "orange",
                color: "white",
                padding: "10px",
                borderRadius: "5px",
              }}
            >
              {this.snackMessage}
            </div>
            {/* <MuiAlert elevation={6} variant="filled" severity="info" onClose={()=>this.snackMessage=null}>{this.snackMessage}</MuiAlert> */}
          </Snackbar>
        </Paper>
      </Container>
    );
  }
}
